<template>
  <dropdown
    :id="'round-overflow-menu-' + round.id"
    ref="dropdown"
    button-class="dropdown-toggle"
    container-class="action-overflow"
  >
    <span slot="label">
      <i class="af-icons af-icons-action-overflow"></i>
    </span>
    <li v-if="showEditOption">
      <a href @click.prevent="event => onClick('edit')">
        {{ labels.edit }}
      </a>
    </li>
    <li>
      <a href @click.prevent="event => onClick('delete')">
        {{ labels.delete }}
      </a>
    </li>
  </dropdown>
</template>

<script>
import { Dropdown } from 'vue-bootstrap';

export default {
  components: {
    Dropdown
  },
  props: {
    round: {
      type: Object,
      required: true
    },
    showEditOption: {
      type: Boolean,
      default: true
    },
    labels: {
      type: Object,
      required: true
    }
  },
  methods: {
    onClick(eventName) {
      this.$emit(eventName, this.round);
      this.$refs.dropdown.close();
    }
  }
};
</script>
